import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from '@material-ui/core'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

import {
  ContainerWrapper,
  DescriptionContentBox,
  DescriptionGridWrapper,
  ImageGridWrapper,
  Wrapper,
} from './ImageTextSection.style'

const ImageTextSection = ({ imageContent, descriptionContent, reverse, bgColor, descriptionMaxWidth = 540 }) => {
  const isMobile = useMobileBreakpoint()

  return (
    <Wrapper bgColor={bgColor} reverse={reverse}>
      <ContainerWrapper disableGutters={isMobile} py={0}>
        <Grid container direction={isMobile ? (reverse ? 'column-reverse' : 'column') : 'row'}>
          <ImageGridWrapper item xs={12} md={6} bgColor={bgColor} reverse={reverse}>
            {imageContent}
          </ImageGridWrapper>
          <DescriptionGridWrapper item xs={12} md={6} reverse={reverse} maxWidth={descriptionMaxWidth}>
            <DescriptionContentBox reverse={reverse}>{descriptionContent}</DescriptionContentBox>
          </DescriptionGridWrapper>
        </Grid>
      </ContainerWrapper>
    </Wrapper>
  )
}

ImageTextSection.propTypes = {
  imageContent: PropTypes.node.isRequired,
  descriptionContent: PropTypes.node.isRequired,
  reverse: PropTypes.bool,
  bgColor: PropTypes.string,
  descriptionMaxWidth: PropTypes.number,
}

export default ImageTextSection
